// components
import { styled, Box, BoxProps, Chip, ChipProps, alpha } from '@mui/material';

export const StyledDutyChipMainContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isRightPositioned'].includes(prop)
})<BoxProps & { isRightPositioned?: boolean }>(
  ({ theme, isRightPositioned }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
    flexDirection: isRightPositioned ? 'column' : 'row'
  })
);

export const StyledDutyChipBox = styled(StyledDutyChipMainContainer, {
  shouldForwardProp: (prop: string) =>
    !['isRightPositioned', 'isTableCell'].includes(prop)
})<
  BoxProps & {
    isRightPositioned?: boolean;
    isTableCell?: boolean;
  }
>(({ theme, isTableCell }) => ({
  gap: theme.spacing(2),
  ...(isTableCell && {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%'
  })
}));

export const StyledDutyChip = styled(Chip, {
  shouldForwardProp: (prop: string) =>
    ![
      'dutyColorBackground',
      'dutyColorBorder',
      'dutyColor',
      'isRightPositioned',
      'isTableCell',
      'isAbsentToday',
      'isFromAnotherCostCenter'
    ].includes(prop)
})<
  ChipProps & {
    dutyColorBackground?: string;
    dutyColorBorder?: string;
    dutyColor?: string;
    isRightPositioned?: boolean;
    isTableCell?: boolean;
    isAbsentToday?: boolean;
    isFromAnotherCostCenter?: boolean;
  }
>(
  ({
    theme,
    dutyColorBackground,
    dutyColorBorder,
    dutyColor,
    isRightPositioned,
    isTableCell,
    isAbsentToday,
    isFromAnotherCostCenter
  }) => ({
    backgroundColor: dutyColorBackground,
    border: isFromAnotherCostCenter
      ? `1px solid ${theme.palette.warning.main}`
      : `1px solid ${dutyColorBorder}`,
    borderBottom:
      dutyColor && !isFromAnotherCostCenter
        ? `6px solid ${dutyColor}`
        : undefined,
    borderRadius: theme.spacing(1.25),
    boxSizing: 'border-box',
    paddingTop: dutyColor ? theme.spacing(1) : 0,
    textTransform: 'uppercase',
    fontSize: '12px',
    height: isTableCell ? '100%' : '28px',
    width: isTableCell ? 'calc(100% - 4px)' : 'auto',
    margin: isTableCell ? '2px' : 0,
    ...(isRightPositioned ? { maxWidth: '30px', overflow: 'hidden' } : {}),
    ...(isAbsentToday && {
      boxShadow: `0 0 0 100px ${alpha(theme.palette.error.main, 0.2)}`,
      border: `2px solid ${theme.palette.error.main}`,
      borderBottom: dutyColor
        ? `6px solid ${theme.palette.error.main}`
        : undefined
    }),

    '& .MuiChip-label': {
      padding: theme.spacing(0, 2)
    }
  })
);
